import { render, staticRenderFns } from "./Salas.vue?vue&type=template&id=1f08f146&scoped=true&"
import script from "./Salas.vue?vue&type=script&lang=js&"
export * from "./Salas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f08f146",
  null
  
)

export default component.exports